import SplashScreen, { SplashScreenStatic } from "../../common/SplashScreen";

export function AdminSplashStatic() {
  return <SplashScreenStatic />;
}

export default function AdminSplash(props) {
  return <SplashScreen {...props} defaultTagline="Панель управления" />;
}
